/**
  * api接口的统一出口
  */
// 首页模块接口
import home from '@/api/home';


// 导出接口
export default {
  home,
}